import useHomeType from 'hooks/useHomeType'
import PublishedRota from '../RotaBuilder/screens/PublishedRota'

export const PublishedRotaScreen = () => {
  const { hasRota } = useHomeType()

  if (!hasRota) {
    return null
  }

  return <PublishedRota />
}
